function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityCreateWo = function SvgActivityCreateWo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.406,
    height: 41.312,
    viewBox: "0 0 41.406 41.312"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M111.408 146.678H72.019a1.009 1.009 0 0 0-1.011 1.009v39.3A1.009 1.009 0 0 0 72.019 188h39.389a1.009 1.009 0 0 0 1.011-1.008v-39.3a1.009 1.009 0 0 0-1.011-1.014Zm-1.01 39.3H73.029V148.7H110.4v37.284Zm-21.76-27.357h12.951a1.009 1.009 0 1 0 0-2.017H88.638a1.009 1.009 0 1 0 0 2.018Zm-6.113 1.189a2.2 2.2 0 1 0-2.2-2.2 2.2 2.2 0 0 0 2.2 2.201Zm6.113 8.535h12.951a1.009 1.009 0 1 0 0-2.017H88.638a1.009 1.009 0 1 0 0 2.018Zm-6.113 1.189a2.2 2.2 0 1 0-2.2-2.2 2.2 2.2 0 0 0 2.2 2.201Zm6.113 8.535h12.951a1.008 1.008 0 1 0 0-2.016H88.638a1.008 1.008 0 1 0 0 2.017Zm-6.113 1.189a2.2 2.2 0 1 0-2.2-2.2 2.2 2.2 0 0 0 2.2 2.201Z",
    "data-name": "header-icon-work order",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    },
    transform: "translate(-71 -146.688)"
  }));
};
export default SvgActivityCreateWo;